import { differenceInYears, isValid, parse } from "date-fns";

const isoDateRegex = /^\d{4}-\d{2}-\d{2}(T\d{2}:\d{2}:\d{2}(\.\d{3})?Z?)?$/;

export function getAgeFromBirthDate(value?: string | null): number | null {
  if (!value) return null;

  const date = isoDateRegex.test(value)
    ? new Date(value)
    : parse(value, "dd/MM/yyyy", new Date());

  if (!isValid(date)) return null;

  return differenceInYears(new Date(), date);
}
